import { styled } from "@mui/material";

import { PrimaryInlineText } from ".";

export const DangerInlineText = styled(PrimaryInlineText)(() => ({
  color: "#ff6a69",
}));
